import { createIcon } from './create-icon'

export const SignOut = createIcon({
  displayName: 'SignOut',
  paths: [
    'M597.397 640v128l-341.376 0.085-0.085-512.085h341.419v128h85.333v-128.085c0-47.061-38.187-85.248-85.291-85.248h-341.462c-47.104 0-85.248 38.187-85.248 85.248v512.171c0 47.061 38.144 85.248 85.248 85.248h341.462c47.104 0 85.291-38.187 85.291-85.248v-128.085h-85.291zM840.858 632.695l90.496-90.539c8.341-8.341 12.51-19.251 12.51-30.165s-4.169-21.824-12.51-30.17l-90.496-90.537c-16.683-16.64-43.691-16.64-60.373 0-16.64 16.683-16.64 43.693 0 60.375l17.681 17.673h-414.165c-23.564 0-42.667 19.102-42.667 42.667s19.102 42.667 42.667 42.667h414.148l-17.664 17.655c-16.64 16.683-16.64 43.691 0 60.373 16.683 16.64 43.691 16.64 60.373 0z'
  ]
})
